var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_vm._v(" "+_vm._s(_vm.$t('footer-web.text'))+" "),_c('br',{staticClass:"no_desktop"}),_vm._v(" "+_vm._s(_vm.$t('footer-web.text-2'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }